import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { SnackbarContent, useSnackbar } from 'notistack';
import { take } from 'ramda';
import { forwardRef, useCallback } from 'react';

const SnackMessage = forwardRef<HTMLDivElement, { id: string | number, details?: string[], title: string }>((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  const theme = useTheme();

  const handleDismiss = useCallback(() => {
    closeSnackbar(props.id);
  }, [props.id, closeSnackbar]);

  const limitedDetails = props.details ? take(5, props.details) : undefined;

  return (
    <Box
      sx={{
        [theme.breakpoints.up('sm')]: {
            minWidth: '344px !important',
        },
      }}
    >
      <SnackbarContent
        ref={ref}
      >
        <Alert
          variant="filled"
          severity="error"
          onClose={handleDismiss}
          sx={{
            width: '100%',
          }}
        >
          <AlertTitle>{props.title}</AlertTitle>
          {limitedDetails ? limitedDetails.map((detail) => <Typography key={detail} variant="body1">{detail}</Typography>) : props.title}
          {limitedDetails && (
          <Typography
            align="right"
            variant="caption"
            sx={{
              display: 'block',
            }}
          >
            {`${limitedDetails?.length}/${props.details?.length}`}
          </Typography>
        )}
        </Alert>
      </SnackbarContent>
    </Box>

  );
});

export default SnackMessage;
